import { ReceiptTypeEnum } from "@prostocheck/shared";

import { IReceiptTypeFilterDef } from "./cash-register.models";

/** Fixed ids so the pickers can point at their own labels — see `toDatePickerFieldProps`. */
export const DATE_FROM_FIELD_ID = "register-date-from";
export const DATE_TO_FIELD_ID = "register-date-to";

/** `all` is a filter of our own; the three types are shared with `libs/ui`. */
export const RECEIPT_TYPE_FILTERS: IReceiptTypeFilterDef[] = [
  { value: "all", labelKey: "receipts.filterAll", namespace: "app" },
  {
    value: ReceiptTypeEnum.Sale,
    labelKey: "receiptType.sale",
    namespace: "common",
  },
  {
    value: ReceiptTypeEnum.Return,
    labelKey: "receiptType.return",
    namespace: "common",
  },
  {
    value: ReceiptTypeEnum.Service,
    labelKey: "receiptType.service",
    namespace: "common",
  },
];

/** Which modal a query param opens — only one renders at a time; a hand-built
 * URL carrying more than one is resolved receipt > zReport > periodReport. */
export const RECEIPT_QUERY_PARAM = "receipt";
export const ZREPORT_QUERY_PARAM = "zReport";
export const PERIOD_REPORT_QUERY_PARAM = "periodReport";
